import { formatInTimeZone } from 'date-fns-tz';

import { css } from '@flipster/styled-system/css';

const LatestUpdate = ({ date }: { date: Date | null }) => {
  return (
    <div className={css({ textStyle: 'Text/S/Regular', textAlign: 'right', color: 'content.default.level-1' })}>
      <span>Latest update:</span>{' '}
      {date ? (
        <time className={css({ wordBreak: 'break-all' })} dateTime={date.toISOString()} translate='no'>
          <span>{formatInTimeZone(date, 'UTC', 'yy.MM.dd HH:mm')}</span> <span>UTC</span>
        </time>
      ) : (
        '-'
      )}
    </div>
  );
};

export default LatestUpdate;
